import React, { useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

import HomeSlider from "../../Components/HomeSlider/HomeSlider";
import CardSlider from "../../Components/CardSlider/CardSlider";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Home = () => {
  const imageNames = [
    "./images/gallery4.jpeg",
    "./images/slider1.png",
    "./images/slider2.png",
    "./images/slider3.png",
    "./images/DeWatermark.ai_1714025244832.png",
    "./images/DeWatermark.ai_1714025203134.png",
  ];


  
 

  return (
    <div>
      <HomeSlider />

      <section className="intro_gifco">
        <div className="intro-content_gifco">
          <h1 style={{ color: "black" }}>WELCOME GIFCO
          </h1>
          <div class="rounded responsive_rounded" ></div>
          <p className="description_gifco fadeInUp-animation">
            <span className="collage-art_gifco"> Welcome to Gifco</span> Auto
            Filters India (GAFI), your go-to source for premium filtration
            solutions tailored for heavy automotive vehicles. With over 26 years
            of expertise, GAFI specializes in diesel filters, fuel strainers,
            and oil filters, meeting diverse automotive needs. Situated in
            Bangalore, India, our cutting-edge facility ensures top-notch
            performance and reliability in every product.
          </p>
        </div>
        <div className="card-container_gifco fadeInLeft-animation">
          <div class="rotate-horizontal">
            <div className="marquee-content">
              <h1>26 YEARS</h1>
            </div>
          </div>
          <div></div>
        </div>
      </section>
       
     
      <div
        data-elementor-type="wp-page"
        data-elementor-id="2841"
        class="elementor elementor-2841 fadeInLeft-animation new_background responsive_product_top"
      >
    
        <div
          data-elementor-type="wp-page"
          data-elementor-id="480"
          class="elementor elementor-480"
        >
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-ce37f7a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="ce37f7a"
            data-element_type="section"
          >
                {/* <h1  className="product_heading">Products</h1>
                <div class="rounded" style={{ marginLeft:"100px" }}></div> */}
            <div class="elementor-container elementor-column-gap-no">
              <ul className="cards">
               
                <li className="cards__item item">
                  <div className="card">
                    <div className="card__image card__image--fence1"></div>
                    <div className="card__content">
                      <div className="card__title">Oil Filter</div>
                      <p className="card__text">
                        An oil filter is really important for a car's engine. It
                        helps to get rid of dirt and keeps the oil clean as it
                        moves around the engine. It's important to change it
                        regularly to keep the engine working well.
                      </p>
                      <button className="getquotes" style={{ color: "white" }}>
                        <Link
                          to="/Oilfilter"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Read more
                        </Link>
                      </button>
                    </div>
                  </div>
                </li>

                <li className="cards__item item">
                  <div className="card">
                    <div className="card__image card__image--fence2"></div>
                    <div className="card__content">
                      <div className="card__title">Diesel Filter</div>
                      <p className="card__text">
                        A diesel filter removes impurities from diesel fuel
                        before reaching the engine, crucial for efficient
                        performance and preventing engine damage.
                      </p>
                      <button className="getquotes" style={{ color: "white" }}>
                        <Link
                          to="/Deselfilter"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Read more
                        </Link>
                      </button>
                    </div>
                  </div>
                </li>

                <li className="cards__item item">
                  <div className="card">
                    <div className="card__image card__image--fence5"></div>
                    <div className="card__content">
                      <div className="card__title">Fuel Strainer</div>
                      <p className="card__text">
                        A fuel strainer is a component that filters out debris
                        and contaminants from the fuel system, ensuring clean
                        fuel supply to the engine for optimal performance.
                      </p>
                      <button className="getquotes">
                        <Link
                          to="/fuelstrainer"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Read more
                        </Link>
                      </button>
                    </div>
                  </div>
                </li>

                <li className="cards__item item responsive_inlinr_filter"  >
                  <div className="card">
                    <div className="card__image card__image--fence4"></div>
                    <div className="card__content">
                      <div className="card__title">Inline Paper Oil Filter</div>
                      <p className="card__text">
                      The inline paper oil filter is recommended to maintain the engine's performance and longevity. It is important to follow the manufacturer's guidelines for filter replacement intervals.
                      </p>
                      <button className="getquotes">
                        <Link
                          to="/inlinepaperOilfilters"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Read more
                        </Link>
                      </button>
                    </div>
                  </div>
                </li>

                <li className="cards__item item">
                  <div className="card">
                    <div className="card__image card__image--fence3"></div>
                    <div className="card__content">
                      <div className="card__title">Hydraulic Filter System</div>
                      <p className="card__text">
                      The system typically consists of filters, housings, and bypass valves to ensure proper filtration. Regular maintenance and replacement of hydraulic filters are necessary to prevent system failures and extend the equipment's lifespan.
                      </p>
                      <button className="getquotes">
                        <Link
                          to="/HydraulicFilterSystem"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Read more
                        </Link>
                      </button>
                    </div>
                  </div>
                </li>


                <li className="cards__item item">
                  <div className="card">
                   
                    {/* <div className="card__content">
                      <div className="card__title">Other Information</div>
                      <p className="card__text">
                      Gifco Company is a leading manufacturer specializing in mass production of high-quality products. With state-of-the-art facilities and advanced technology, we consistently deliver superior products to meet market demands. Our extensive experience allows us to optimize production processes, ensuring efficiency and cost-effectiveness. Gifco Company is committed to producing products of the highest standards, backed by stringent quality control measures. We take pride in our ability to meet mass production requirements while maintaining exceptional product quality and customer satisfaction.

                      </p>
                      
                    </div> */}
                  </div>
                </li>
                
                
              </ul>
              
            </div>
          </section>
        </div>

        <CardSlider imageNames={imageNames} />
        <div style={{ marginTop: "30px" }}>
          <h3 style={{ fontSize: "34px", textAlign: "center" }}>Our Clients
          </h3>
          {/* <div class="rounded resposnive_client" ></div> */}
          
          <div className="client_container">
          
            <div>
              <img
                src="./images/verseautotech1.PNG"
                alt=""
                style={{ marginTop: "30px", marginRight: "30px" }}
              />
            </div>
            <div>
              <img src="./images/verseautotech2.PNG" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
